import './calendarEventFormNew.less';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AntModal, createContainer, ModalPosition } from 'controls/react/ant/antModal';
import { Section } from 'controls/react/layout/section';
import { Toolbar } from 'controls/react/layout/toolbar';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput, AntTextArea } from 'controls/react/ant/antInput';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { translator } from 'core/localization/localization';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { computed, makeAutoObservable, makeObservable, observable } from 'mobx';
import { apiFetchObservable, CachedValue } from 'framework/api';
import { getTimeZones } from './calendar/api';
import { observer } from 'mobx-react';
import moment from 'moment';
import { AntDatePicker } from 'controls/react/ant/antDatePicker';
import { ApplicationState } from 'framework/applicationState';
import RRule, { Frequency as RruleFrequency } from 'rrule';
import { AntTags } from 'controls/react/ant/AntTags';
import { AntRadioGroup } from 'controls/react/ant/antRadio';
import { Button, Radio } from 'antd';
import { ALL_WEEKDAYS, Weekday } from 'rrule/dist/esm/src/weekday';
import { newGuid } from 'tools/guid';
import { MobxManager, ModelValidator } from 'framework/mobx-integration';
import { getTzOffsetDiffs } from 'tools/dateTimeUtils';
import { parseDateFormat } from 'tools/dateTime/parseDateFormat';
import { parseStringValueToEnum, parseStringValueToRrule } from './calendar/calendarUtils';
import { AntInputNumber } from 'controls/react/ant/antInputNumber';
import { State } from '../../tools';
import b_ from 'b_';
import { BoxView } from 'controls/react/layout/boxView';
import { fieldNamesIdName } from 'controls/react/ant/ant-select/types';
import { fromStringsArray } from 'controls/react/ant/ant-select/utils/fromStringsArray';

const momentDateTimeFormat = () =>
	parseDateFormat(ApplicationState.dateTimeFormat).replace('.SSS', '').replace(':ss', '');

export const scheduleTranslates = {
	'REPEAT': { en: 'Repeat', no: 'Gjenta' },
	'EVERY': { en: 'every', no: 'Hver' },
	'SECONDLY': { en: 'Secondly', no: 'Sekund' },
	'MINUTELY': { en: 'Minutely', no: 'Minutt' },
	'HOURLY': { en: 'Hourly', no: 'Time' },
	'DAILY': { en: 'Daily', no: 'Daglig' },
	'WEEKLY': { en: 'Weekly', no: 'Ukentlig' },
	'MONTHLY': { en: 'Monthly', no: 'M\u00e5nedlig' },
	'YEARLY': { en: 'Yearly', no: 'Årlig' },
	'ON_DAY': { en: 'on day', no: 'P\u00e5 dag' },
	'RRULE': { en: 'RRULE', no: 'Gjentagelse' },
	'SECONDS': { en: 'second(s)', no: 'andre(r)' },
	'MINUTE': { en: 'minute(s)', no: 'minutte(r)' },
	'HOUR': { en: 'hour(s)', no: 'Time(r)' },
	'DAY': { en: 'day(s)', no: 'dag(er)' },
	'WEEK': { en: 'week(s)', no: 'Uke(r)' },
	'MONTH': { en: 'month(s)', no: 'm\u00e5ned(er)' },
	'YEAR': { en: 'year(s)', no: 'År' },
	'START': { en: 'Start time', no: 'Starttid' },
	'END': { en: 'End', no: 'Slutt' },
	'NEVER': { en: 'Never', no: 'Aldri' },
	'ON_DATE': { en: 'On date', no: 'P\u00E5 dato' },
	'ON_THE': { en: 'on the', no: 'P\u00E5 den' },
	'FIRST': { en: 'First', no: 'F\u00F8rste' },
	'SECOND': { en: 'Second', no: 'Andre' },
	'THIRD': { en: 'Third', no: 'Tredje' },
	'FOURTH': { en: 'Fourth', no: 'Fjerde' },
	'LAST': { en: 'Last', no: 'Siste' },
	'WEEKDAY': { en: 'Weekday', no: 'Ukedag' },
	'WEEKEND_DAY': { en: 'Weekend day', no: 'Helgedag' },
	'ON': { en: 'On', no: 'P\u00E5' },
	'MO': { en: 'Monday', no: 'Mandag' },
	'TU': { en: 'Tuesday', no: 'Tirsdag' },
	'WE': { en: 'Wednesday', no: 'Onsdag' },
	'TH': { en: 'Thursday', no: 'Torsdag' },
	'FR': { en: 'Friday', no: 'Fredag' },
	'SA': { en: 'Saturday', no: 'L\u00F8rdag' },
	'SU': { en: 'Sunday', no: 'S\u00F8ndag' },
	'JAN': { en: 'Jan', no: 'Jan' },
	'FEB': { en: 'Feb', no: 'Feb' },
	'MAR': { en: 'Mar', no: 'Mar' },
	'APR': { en: 'Apr', no: 'Apr' },
	'MAY': { en: 'May', no: 'Mai' },
	'JUN': { en: 'Jun', no: 'Jun' },
	'JUL': { en: 'Jul', no: 'Jul' },
	'AUG': { en: 'Aug', no: 'Aug' },
	'SEP': { en: 'Sep', no: 'Sep' },
	'OCT': { en: 'Oct', no: 'Okt' },
	'NOV': { en: 'Nov', no: 'Nov' },
	'DEC': { en: 'Dec', no: 'Des' },
	'Time zone': { no: 'Tidssone' },
	'Recurring event': { no: 'Gjentatt hendelse' },
	'SELECT_WEEKDAY': { en: 'Select at least one day of week', no: 'Velg minst én ukedag' },
	'Event': { no: 'Hendelse' },
	'Recurring Event': { no: 'Gjentatt hendelse' },
	'From time': { no: 'Fra tid' },
	'To time': { no: 'Til tid' },
};
const i18n = translator(scheduleTranslates);
const bModal = b_.with('calendar-event-form');

export const CeeViewHistoricMaintenanceEventStorageKey = 'cw.services.maintenance_historic_event';

export type DatesType = 'onlyStart' | 'range';

const currentTimeInTimezone = (timezone: string) =>
	moment(moment().valueOf() - getTzOffsetDiffs(moment.tz.guess(), timezone) * 60000).valueOf();

export class CalendarEventBase {
	start: number;
	end?: number;
	id?: string;
	title?: string;
	comment: string;
	timezone: string;
	rruleObject?: RRule;
	created?: string;
	lastModified?: string;
	startIsCurrentTime: boolean;
	editable: boolean;

	constructor(options?: object) {
		this.editable = true;
		if (options) {
			Object.assign(this, options);
		}
	}

	getMaintenanceData() {
		this.updateCurrentTime();
		return {
			fromTime: moment(this.start).format('YYYY-MM-DDTHH:mm:ss'),
			toTime: moment(this.end).format('YYYY-MM-DDTHH:mm:ss'),
			reason: this.title,
			timeZone: this.timezone,
		};
	}

	updateCurrentTime() {
		if (this.startIsCurrentTime) {
			this.start = currentTimeInTimezone(this.timezone);
		}
	}
}

export class CalendarEvent extends CalendarEventBase {
	validator = new ModelValidator(this);

	constructor(options?: object) {
		super(options);
		makeObservable(this, {
			title: observable,
			comment: observable,
			timezone: observable,
			start: observable,
			end: observable,
		});
		this.validator.required('title').required('timezone');
	}
}

class CalendarEventFormStore {
	event: CalendarEvent;
	timezones: CachedValue<string[]>;
	calendarTimezone?: string;
	isRecurring: boolean;
	recurringFormValid: boolean = true;
	validator = new ModelValidator(this);
	datesType: DatesType;
	get modalTitle(): string {
		return this.isRecurring ? i18n('Recurring Event') : i18n('Event');
	}

	constructor(private props: CalendarEventFormProps) {
		this.event = new CalendarEvent(this.props.event);
		this.event.startIsCurrentTime = props.startIsCurrentTime ?? false;
		this.datesType = props.datesType ?? 'range';
		this.calendarTimezone = props.calendarTimezone;
		if (!this.event.id) {
			this.event.id = newGuid();
		}
		this.timezones = apiFetchObservable(getTimeZones());
		this.setIsRecurring(!!this.event.rruleObject);
		makeAutoObservable(this, {
			updateDisabled: computed,
			start: computed,
			end: computed,
		});

		this.validator
			.add('end', {
				callback: () => {
					if (this.datesType == 'onlyStart') return true;

					return this.validatePeriod();
				},
				reactionExpression: () => [this.start, this.end],
			})
			.add('start', {
				callback: () => {
					if (this.datesType == 'onlyStart') return true;

					return this.validatePeriod();
				},
				reactionExpression: () => [this.start, this.end],
			});
		State.mainApp.registerForOnNavigate(this.onCancel);
	}

	validatePeriod = () => {
		return (
			(this.start.isSame(this.end, 'day') && this.end.format('HH:mm') == '00:00') ||
			this.event.end - this.event.start > 0
		);
	};

	setIsRecurring = (value: boolean) => {
		this.isRecurring = value;
		if (!value) {
			this.event.rruleObject = undefined;
		}
	};

	setRecurringFormValid = (value: boolean) => {
		this.recurringFormValid = value;
	};

	set range(value: [moment.Moment, moment.Moment]) {
		this.event.start = value?.[0].valueOf();
		this.event.end = value?.[1].valueOf();
	}

	get start() {
		return moment(this.event.start);
	}

	set start(value: moment.Moment) {
		this.event.start = value?.valueOf();
		this.event.startIsCurrentTime = false;
	}

	get end() {
		return moment(this.event.end);
	}

	set end(value: moment.Moment) {
		this.event.end = value?.valueOf();
	}

	get updateDisabled() {
		return !this.validator.valid || (this.isRecurring && !this.recurringFormValid);
	}

	onCancel = () => {
		this.props.onCancel();
		this.destroy();
	};

	onDelete = () => {
		this.props.onDelete(this.event);
		this.destroy();
	};

	onOk = () => {
		if (!this.validator.valid) {
			return;
		}
		if (this.props.mode == 'create') {
			this.event.created = moment().utc().format('YYYYMMDDTHHmmssZ');
		}
		this.event.lastModified = moment().utc().format('YYYYMMDDTHHmmssZ');
		this.event.updateCurrentTime();
		this.props.onSave(this.event);
		this.destroy();
	};

	destroy = () => {
		this.validator.destroy();
	};

	onEndEvent = () => {
		// we need to end event in calendar, so we use it's timezone as source of truth
		this.event.end = currentTimeInTimezone(this.calendarTimezone || this.event.timezone);
		this.onOk();
	};

	get endEventText() {
		return this.props.endEventText;
	}

	get endEventDisabledText() {
		return this.props.endEventDisabledText;
	}

	get showEndEvent() {
		if (this.isRecurring) {
			return true;
		}
		const now = currentTimeInTimezone(this.calendarTimezone || this.event.timezone);
		return this.event.end > now && this.event.start < now;
	}
}

export class CalendarEventFormProps {
	event: CalendarEventBase;
	mode: 'create' | 'update';
	datesType?: DatesType;
	disabled?: boolean;
	onSave: (event: CalendarEventBase) => void;
	onDelete?: (event: CalendarEventBase) => void;
	onCancel?: () => void;
	positionType?: ModalPosition;
	positionAnchor?: React.MutableRefObject<HTMLElement> | HTMLElement;
	startIsCurrentTime?: boolean;
	disableRrule?: boolean;
	onEventEnd?: (event: CalendarEventBase) => void;
	endEventText?: string;
	calendarTimezone?: string;
	endEventDisabledText?: string;
	infoMessage?: string;
}

const bCal = b_.with('calendar-event');
export const CalendarEventFormNew = observer(
	class CalendarEventFormNew extends React.Component<CalendarEventFormProps> {
		store: CalendarEventFormStore;
		constructor(props: CalendarEventFormProps) {
			super(props);
			this.store = new CalendarEventFormStore(props);
		}

		modalFooter() {
			return (
				<Footer
					mode={this.props.mode}
					onOk={this.store.onOk}
					onCancel={this.store.onCancel}
					onDelete={this.store.onDelete}
					onEndEvent={this.store.onEndEvent}
					endEventText={this.store.endEventText}
					endEventShowed={this.store.endEventText && this.store.showEndEvent}
					endEventDisabled={this.store.isRecurring}
					endEventDisabledText={this.store.endEventDisabledText}
					disabled={this.props.disabled || this.store.updateDisabled}
				/>
			);
		}

		render() {
			return (
				<AntModal
					open={true}
					title={this.store.modalTitle}
					className={bCal()}
					onCancel={this.store.onCancel}
					width={500}
					resizable={false}
					mask={{ closable: false }}
					draggableHandle={'.toolbar'}
					positionType={this.props.positionType ?? ModalPosition.TopLeft}
					positionAnchor={this.props.positionAnchor}
					footer={this.modalFooter()}
					rootClassName={bModal()}
				>
					<Section appearance={'none'} contentPadding height={'fit-expand-only'} childrenPadding={true}>
						{!!this.props.infoMessage && (
							<BoxView type={'info-2'} rounded={false} border={true}>
								{this.props.infoMessage}
							</BoxView>
						)}
						<FormEntryNew
							label={i18n('Name')}
							model={this.store.event}
							modelField={'title'}
							disabled={this.props.disabled}
						>
							<AntInput />
						</FormEntryNew>
						<FormEntryNew
							label={i18n('Comment')}
							model={this.store.event}
							modelField={'comment'}
							disabled={this.props.disabled}
						>
							<AntTextArea height={80} />
						</FormEntryNew>
					</Section>
					<Section appearance={'none'} contentPadding height={'fit-expand-only'}>
						<FormEntryNew
							label={i18n('Time zone')}
							model={this.store.event}
							modelField={'timezone'}
							disabled={this.props.disabled}
						>
							<AntSelect
								options={fromStringsArray(this.store.timezones.data)}
								loading={this.store.timezones.loading}
							/>
						</FormEntryNew>
					</Section>
					<Section
						appearance={'none'}
						contentPadding
						height={'fit-expand-only'}
						direction={'row'}
						contentClass={bCal('period')}
					>
						{this.store.datesType == 'range' && (
							<FormEntryNew
								label={i18n('From time')}
								model={this.store}
								modelField={'start'}
								disabled={this.props.disabled}
							>
								<AntDatePicker
									className={bCal('period-start')}
									format={momentDateTimeFormat()}
									styles={{ popup: { root: { zIndex: 100_000 } } }}
									showTime={true}
								/>
							</FormEntryNew>
						)}
						{this.store.datesType == 'range' && (
							<FormEntryNew
								label={i18n('To time')}
								model={this.store}
								modelField={'end'}
								disabled={this.props.disabled}
							>
								<AntDatePicker
									className={bCal('period-end')}
									format={momentDateTimeFormat()}
									styles={{ popup: { root: { zIndex: 100_000 } } }}
									showTime={true}
								/>
							</FormEntryNew>
						)}
						{this.store.datesType == 'onlyStart' && (
							<FormEntryNew
								label={i18n('From time')}
								model={this.store}
								modelField={'start'}
								disabled={this.props.disabled}
							>
								<AntDatePicker
									className={bCal('period-start')}
									format={momentDateTimeFormat()}
									styles={{ popup: { root: { zIndex: 100_000 } } }}
									showTime={true}
								/>
							</FormEntryNew>
						)}
					</Section>
					{this.props.disableRrule != true && (
						<Section
							appearance={'frame-top-only'}
							title={i18n('Recurring event')}
							height={'fit-expand-only'}
						>
							<Toolbar>
								<AntSwitch
									size={'small'}
									value={this.store.isRecurring}
									onChange={(v) => this.store.setIsRecurring(v)}
									disabled={this.props.disabled}
								/>
							</Toolbar>
							{this.store.isRecurring && (
								<FormEntryNew
									model={this.store.event}
									modelField={'rruleObject'}
									disabled={this.props.disabled}
								>
									<RecurringEventForm
										timeZone={this.store.event.timezone}
										startDate={this.store.event.start}
										onValidChange={this.store.setRecurringFormValid}
									/>
								</FormEntryNew>
							)}
						</Section>
					)}
				</AntModal>
			);
		}
	},
);

class FooterProps {
	mode: 'create' | 'update';
	onOk: () => void;
	onDelete: () => void;
	onCancel: () => void;
	onEndEvent?: () => void;
	disabled?: boolean;

	endEventText?: string;
	endEventShowed?: boolean;
	endEventDisabled?: boolean;
	endEventDisabledText?: string;
}

const Footer = (props: FooterProps) => {
	return (
		<Toolbar>
			{props.mode == 'update' && (
				<Button position={'before-title'} onClick={props.onDelete} key={'delete'} disabled={props.disabled}>
					{i18n('Delete')}
				</Button>
			)}
			{props.mode == 'update' && props.endEventShowed && (
				<Button
					position={'at-the-end'}
					onClick={props.onEndEvent}
					key={'end'}
					disabled={props.endEventDisabled || props.disabled}
					title={props.endEventDisabled ? props.endEventDisabledText : null}
				>
					{props.endEventText ?? i18n('End event')}
				</Button>
			)}
			<Button onClick={props.onOk} position={'at-the-end'} type={'primary'} key={'ok'} disabled={props.disabled}>
				{props.mode == 'create' ? i18n('Create') : i18n('Update')}
			</Button>
			<Button onClick={props.onCancel} position={'at-the-end'} key={'cancel'}>
				{i18n('Cancel')}
			</Button>
		</Toolbar>
	);
};

class RecurringEventFormProps {
	excludeFrequencies?: Frequency[] | string[];
	value?: RRule;
	timeZone: string;
	startDate?: number;
	disabled?: boolean;
	onChange?: (value: RRule) => void;
	onValidChange?: (valid: boolean) => void;
}

export enum Frequency {
	YEARLY = 'YEARLY',
	MONTHLY = 'MONTHLY',
	WEEKLY = 'WEEKLY',
	DAILY = 'DAILY',
	HOURLY = 'HOURLY',
	MINUTELY = 'MINUTELY',
	SECONDLY = 'SECONDLY',
}

class RecurringEventFormStore {
	rrule: RruleType = {};
	frequencyDataSource: { label: string; value: Frequency }[];
	endDataSource: { label: string; value: string }[];
	frequencyState = Frequency.DAILY;
	frequencyValue = 1;
	endType: 'ON_DATE' | 'NEVER' = 'NEVER';
	until?: number;

	mobx = new MobxManager();
	validator = new ModelValidator(this);

	get isValid() {
		return this.validator.valid;
	}

	get frequency() {
		return this.frequencyState;
	}

	// by-day/month settings of one frequency have a different meaning (or none) for another one
	set frequency(value: Frequency) {
		if (value != this.frequencyState) {
			this.rrule = {};
		}
		this.frequencyState = value;
	}

	get endValue() {
		if (!this.until) {
			return undefined;
		}
		return moment(this.until);
	}

	set endValue(val: moment.Moment) {
		this.until = val?.valueOf();
	}

	get repeatUnit() {
		switch (this.frequency) {
			case Frequency.MINUTELY: {
				return i18n('MINUTE');
			}
			case Frequency.HOURLY: {
				return i18n('HOUR');
			}
			case Frequency.DAILY: {
				return i18n('DAY');
			}
			case Frequency.WEEKLY: {
				return i18n('WEEK');
			}
			case Frequency.MONTHLY: {
				return i18n('MONTH');
			}
			case Frequency.YEARLY: {
				return i18n('YEAR');
			}
		}
	}

	constructor(private props: RecurringEventFormProps) {
		makeAutoObservable(this);
		this.mobx.reaction(
			(x) => this.rRule,
			(result) => {
				this.props.onChange(this.rRuleObject);
			},
		);
		this.mobx.reaction(
			() => this.isValid,
			(valid) => this.props.onValidChange?.(valid),
			{ fireImmediately: true },
		);
		this.validator
			.required('frequencyValue')
			.required('endValue', () => this.endType != 'NEVER')
			.add('rrule', {
				message: i18n('SELECT_WEEKDAY'),
				callback: () => this.frequency != Frequency.WEEKLY || !!this.rrule.byweekday?.length,
				reactionExpression: () => [this.frequency, this.rrule.byweekday?.length],
			});
	}

	updateProps = (props: RecurringEventFormProps) => {
		this.props = props;
	};

	get rRuleObject() {
		const ruleObj: { [id: string]: any } = {
			freq: RRule[this.frequency],
			interval: this.frequencyValue,
			byweekday: this.rrule.byweekday?.map((x) => parseStringValueToRrule(x)) ?? [],
			bymonthday: this.rrule.bymonthday,
			bymonth: this.rrule.bymonth,
			bysetpos: this.rrule.bysetpos,
		};

		if (this.endValue) {
			ruleObj.until = moment(
				this.until + getTzOffsetDiffs(moment.tz.guess(), this.props.timeZone, this.until) * 60000,
			)
				.toDate()
				.toISOString();
		}

		return new RRule(ruleObj);
	}

	get rRule() {
		return this.rRuleObject.toString();
	}

	setRrule = (rrule?: RRule) => {
		if (!rrule) {
			return;
		}

		this.frequency = convertRruleFrequencyToFrequency(rrule.options.freq);
		this.frequencyValue = rrule.options.interval;
		if (rrule.options.byweekday?.length) {
			this.rrule.byweekday = rrule.options.byweekday.map((x) => new Weekday(x).toString());
		}
		if (rrule.options.bymonthday?.length) {
			this.rrule.bymonthday = rrule.options.bymonthday[0];
		}
		if (rrule.options.bymonth?.length) {
			this.rrule.bymonth = rrule.options.bymonth[0];
		}
		if (rrule.options.bysetpos?.length) {
			this.rrule.bysetpos = rrule.options.bysetpos[0];
		}
		if (rrule.options.until) {
			this.until =
				moment.utc(rrule.options.until).valueOf() -
				getTzOffsetDiffs(moment.tz.guess(), this.props.timeZone, moment.utc(rrule.options.until).toDate()) *
					60000;
			this.endType = 'ON_DATE';
		}
	};

	init = () => {
		this.frequencyDataSource = [
			{
				label: i18n('MINUTELY'),
				value: Frequency.MINUTELY,
			},
			{
				label: i18n('HOURLY'),
				value: Frequency.HOURLY,
			},
			{
				label: i18n('DAILY'),
				value: Frequency.DAILY,
			},
			{
				label: i18n('WEEKLY'),
				value: Frequency.WEEKLY,
			},
			{
				label: i18n('MONTHLY'),
				value: Frequency.MONTHLY,
			},
			{
				label: i18n('YEARLY'),
				value: Frequency.YEARLY,
			},
		].filter((x) => !this.props.excludeFrequencies?.includes(x.value));

		this.endDataSource = [
			{
				label: i18n('NEVER'),
				value: 'NEVER',
			},
			{
				label: i18n('ON_DATE'),
				value: 'ON_DATE',
			},
		];

		this.setRrule(this.props.value);
		this.props.onChange(this.rRuleObject);
	};

	destroy() {
		this.mobx.destroy();
	}
}

const convertRruleFrequencyToFrequency = (val: number): Frequency => {
	for (const item in RruleFrequency) {
		if (Number(item) == val) {
			return parseStringValueToEnum(Frequency, RruleFrequency[item]);
		}
	}
};

const b = b_.with('recurring-event');

export class RecurringEventFormImpl extends React.Component<RecurringEventFormProps> {
	store: RecurringEventFormStore;

	constructor(props: RecurringEventFormProps) {
		super(props);
		this.store = new RecurringEventFormStore(props);
	}

	componentDidMount() {
		this.store.init();
	}

	componentDidUpdate(prevProps: Readonly<RecurringEventFormProps>, prevState: Readonly<{}>, snapshot?: any) {
		this.store.updateProps(this.props);
	}

	componentWillUnmount() {
		this.store.destroy();
	}

	render() {
		return (
			<Section appearance={'none'} containerClass={b()}>
				<Section appearance={'none'} direction={'row'} contentPadding>
					<Section appearance={'none'} width={'oneThird'}>
						<FormEntryNew
							label={i18n('REPEAT')}
							model={this.store}
							modelField={'frequency'}
							disabled={this.props.disabled}
						>
							<AntSelect options={this.store.frequencyDataSource} sortOptions={false} />
						</FormEntryNew>
					</Section>
					<FormEntryNew
						label={i18n('EVERY')}
						model={this.store}
						modelField={'frequencyValue'}
						disabled={this.props.disabled}
					>
						<AntInputNumber className={b('every-input')} />
						{this.store.repeatUnit}
					</FormEntryNew>
				</Section>
				{this.store.frequency == Frequency.WEEKLY && (
					<Section appearance={'none'} direction={'row'} className={b('days-of-week')}>
						<FormEntryNew model={this.store} modelField={'rrule'} disabled={this.props.disabled}>
							<WeeklyForm startDate={this.props.startDate} />
						</FormEntryNew>
					</Section>
				)}
				{this.store.frequency == Frequency.MONTHLY && (
					<Section appearance={'none'}>
						<FormEntryNew model={this.store} modelField={'rrule'} disabled={this.props.disabled}>
							<MonthlyForm />
						</FormEntryNew>
					</Section>
				)}
				{this.store.frequency == Frequency.YEARLY && (
					<Section appearance={'none'} contentPadding direction={'row'} width={'full'}>
						<FormEntryNew
							label={i18n('ON_THE')}
							model={this.store}
							modelField={'rrule'}
							disabled={this.props.disabled}
						>
							<YearlyForm />
						</FormEntryNew>
					</Section>
				)}
				<Section appearance={'none'} direction={'row'} contentPadding>
					<Section appearance={'none'} width={'oneThird'}>
						<FormEntryNew
							label={i18n('END')}
							model={this.store}
							modelField={'endType'}
							disabled={this.props.disabled}
						>
							<AntSelect options={this.store.endDataSource} />
						</FormEntryNew>
					</Section>
					{this.store.endType == 'ON_DATE' && (
						<FormEntryNew model={this.store} modelField={'endValue'} disabled={this.props.disabled}>
							<AntDatePicker
								className={b('end')}
								styles={{ popup: { root: { zIndex: 100000 } } }}
								format={momentDateTimeFormat()}
								showTime
							/>
						</FormEntryNew>
					)}
				</Section>
			</Section>
		);
	}
}
export const RecurringEventForm = observer(RecurringEventFormImpl);

type RruleType = {
	byweekday?: string[];
	bymonthday?: number;
	bymonth?: number;
	bysetpos?: number;
};

class RruleProps {
	value?: RruleType;
	disabled?: boolean;
	startDate?: number;
	onChange?: (value: RruleType) => void;
}

const weekdayFromDate = (timestamp?: number): string[] => {
	if (timestamp == null) {
		return [];
	}
	const jsDay = moment(timestamp).day();
	return [ALL_WEEKDAYS[(jsDay + 6) % 7]];
};

const WeeklyForm = (props: RruleProps) => {
	const [byWeekday, setByWeekday] = useState(() =>
		props.value.byweekday?.length ? props.value.byweekday : weekdayFromDate(props.startDate),
	);
	const options = useRef(ALL_WEEKDAYS.map((x) => x.toString()));
	const onChange = useCallback((value: string[]) => {
		setByWeekday(value);
		props.onChange({ byweekday: value });
	}, []);

	useEffect(() => {
		if (!props.value.byweekday?.length && byWeekday?.length) {
			props.onChange({ byweekday: byWeekday });
		}
	}, []);

	return <AntTags options={options.current} value={byWeekday} onChange={onChange} disabled={props.disabled} />;
};

const MonthlyForm = (props: RruleProps) => {
	const [monthlyType, setMonthlyType] = useState(!props.value.bysetpos ? 'BYMONTHDAY' : 'BYSETPOS');
	const [byMonthDay, setByMonthDay] = useState(props.value.bymonthday);
	const [byStepPos, setByStepPos] = useState(props.value.bysetpos);
	const [byWeekday, setByWeekday] = useState(props.value.byweekday);

	const weekOptions = useRef(
		ALL_WEEKDAYS.map((x) => ({
			name: i18n(x),
			id: x,
		})),
	);

	const daysOptions = useRef(
		new Array(31)
			.fill(0)
			.reduce((result, current, index) => [...result, index + 1], [])
			.map((x: number) => ({ name: x.toString(), id: x })),
	);

	const byStepPosOptions = useRef([
		{ name: i18n('FIRST'), id: 1 },
		{ name: i18n('SECOND'), id: 2 },
		{ name: i18n('THIRD'), id: 3 },
		{ name: i18n('FOURTH'), id: 4 },
		{ name: i18n('LAST'), id: -1 },
	]);

	useEffect(() => {
		if (!props.value.bymonthday && !props.value.bysetpos && !props.value.byweekday?.length) {
			resetForm(monthlyType);
		} else {
			props.onChange({
				byweekday: byWeekday,
				bymonthday: byMonthDay,
				bysetpos: byStepPos,
			});
		}
	}, []);

	const resetForm = useCallback((currentMonthlyType: string) => {
		const result = {
			byweekday: currentMonthlyType == 'BYMONTHDAY' ? undefined : ['MO'],
			bymonthday: currentMonthlyType == 'BYMONTHDAY' ? 1 : undefined,
			bysetpos: currentMonthlyType == 'BYMONTHDAY' ? undefined : 1,
		};
		setByMonthDay(result.bymonthday);
		setByStepPos(result.bysetpos);
		setByWeekday(result.byweekday);
		props.onChange(result);
	}, []);

	const onMonthlyTypeChange = useCallback((value: string) => {
		setMonthlyType(value);
		resetForm(value);
	}, []);

	const onMonthDayChange = useCallback(
		(value: number) => {
			setByMonthDay(value);
			props.onChange({
				byweekday: byWeekday,
				bymonthday: value,
				bysetpos: byStepPos,
			});
		},
		[byWeekday, byStepPos],
	);

	const onStepPosChange = useCallback(
		(value: number) => {
			setByStepPos(value);
			props.onChange({
				byweekday: byWeekday,
				bymonthday: byMonthDay,
				bysetpos: value,
			});
		},
		[byWeekday, byMonthDay],
	);

	const onWeeklyChange = useCallback(
		(value: string) => {
			setByWeekday([value]);
			props.onChange({
				byweekday: [value],
				bymonthday: byMonthDay,
				bysetpos: byStepPos,
			});
		},
		[byMonthDay, byStepPos],
	);

	return (
		<AntRadioGroup value={monthlyType} onChange={onMonthlyTypeChange} disabled={props.disabled}>
			<Section appearance={'none'} contentPadding direction={'row'}>
				<Radio value={'BYMONTHDAY'}>{monthlyType != 'BYMONTHDAY' && i18n('ON_DAY')}</Radio>
				{monthlyType == 'BYMONTHDAY' && (
					<FormEntryNew label={i18n('ON_DAY')} validationOnly>
						<AntSelect
							value={byMonthDay}
							onChange={onMonthDayChange}
							fieldNames={fieldNamesIdName}
							options={daysOptions.current}
							sortOptions={false}
							disabled={props.disabled}
						/>
					</FormEntryNew>
				)}
			</Section>
			<Section appearance={'none'} contentPadding direction={'row'}>
				<Radio value={'BYSETPOS'}>{monthlyType != 'BYSETPOS' && i18n('ON_THE')}</Radio>
				{monthlyType == 'BYSETPOS' && (
					<>
						<FormEntryNew label={i18n('ON_THE')} validationOnly>
							<AntSelect
								value={byStepPos}
								onChange={onStepPosChange}
								options={byStepPosOptions.current}
								fieldNames={fieldNamesIdName}
								sortOptions={false}
								disabled={props.disabled}
							/>
						</FormEntryNew>
						<FormEntryNew validationOnly>
							<AntSelect
								options={weekOptions.current}
								value={byWeekday[0]}
								onChange={onWeeklyChange}
								fieldNames={fieldNamesIdName}
								sortOptions={false}
								disabled={props.disabled}
							/>
						</FormEntryNew>
					</>
				)}
			</Section>
		</AntRadioGroup>
	);
};

const YearlyForm = (props: RruleProps) => {
	const [byMonth, setByMonth] = useState(props.value.bymonth ?? 1);
	const [byMonthDay, setByMonthDay] = useState(props.value.bymonthday ?? 1);

	const dayOptions = useRef(
		new Array(31)
			.fill(0)
			.reduce((result, current, index) => [...result, index + 1], [])
			.map((x: number) => ({ name: x.toString(), id: x })),
	);

	const monthOptions = useRef([
		{ name: i18n('JAN'), id: 1 },
		{ name: i18n('FEB'), id: 2 },
		{ name: i18n('MAR'), id: 3 },
		{ name: i18n('APR'), id: 4 },
		{ name: i18n('MAY'), id: 5 },
		{ name: i18n('JUN'), id: 6 },
		{ name: i18n('JUL'), id: 7 },
		{ name: i18n('AUG'), id: 8 },
		{ name: i18n('SEP'), id: 9 },
		{ name: i18n('OCT'), id: 10 },
		{ name: i18n('NOV'), id: 11 },
		{ name: i18n('DEC'), id: 12 },
	]);

	useEffect(() => {
		props.onChange({
			bymonthday: byMonthDay,
			bymonth: byMonth,
		});
	}, []);

	const onDayChange = useCallback(
		(value: number) => {
			setByMonthDay(value);
			props.onChange({
				bymonthday: value,
				bymonth: byMonth,
			});
		},
		[byMonth],
	);

	const onMonthChange = useCallback(
		(value: number) => {
			setByMonth(value);
			props.onChange({
				bymonthday: byMonthDay,
				bymonth: value,
			});
		},
		[byMonthDay],
	);

	return (
		<>
			<FormEntryNew validationOnly>
				<AntSelect
					options={monthOptions.current}
					fieldNames={fieldNamesIdName}
					value={byMonth}
					onChange={onMonthChange}
					sortOptions={false}
					disabled={props.disabled}
				/>
			</FormEntryNew>
			<FormEntryNew validationOnly>
				<AntSelect
					options={dayOptions.current}
					fieldNames={fieldNamesIdName}
					value={byMonthDay}
					onChange={onDayChange}
					sortOptions={false}
					disabled={props.disabled}
				/>
			</FormEntryNew>
		</>
	);
};

export function openCalendarEventForm(options: CalendarEventFormProps) {
	const { onSave, onCancel, onDelete, ...others } = options;
	const [root, destroy] = createContainer();
	const onFormSave = (event: CalendarEventBase) => {
		onSave(event);
		destroy();
	};
	const onFormDelete = (event: CalendarEventBase) => {
		onDelete(event);
		destroy();
	};
	const onFormCancel = () => {
		root.unmount();
		destroy();
		onCancel?.();
	};
	root.render(
		<CalendarEventFormNew onSave={onFormSave} onDelete={onFormDelete} onCancel={onFormCancel} {...others} />,
	);
}

export type ShowMaintenanceFormConfig = {
	date: Date;
	onSave: (ev: CalendarEventBase) => Promise<boolean>;
	positionType?: ModalPosition;
	anchor?: React.MutableRefObject<HTMLElement> | HTMLElement;
	onCancel?: () => void;
	timeZone?: string;
	comment?: string;
	datesType?: DatesType;
	disableRrule?: boolean;
	startIsCurrentTime?: boolean;
	infoMessage?: string;
};

export function showCreateMaintenanceEventForm(config: ShowMaintenanceFormConfig) {
	return new Promise<boolean>((resolve) => {
		const startTime = getStartTime(config.date, config.timeZone);
		const startDate = new Date(config.date);
		startDate.setHours(startTime[0]);
		startDate.setMinutes(startTime[1]);
		startDate.setSeconds(startTime[2]);

		const endDate = new Date(config.date);
		endDate.setHours(startTime[0] + 1);
		endDate.setMinutes(0);
		endDate.setSeconds(0);

		openCalendarEventForm({
			event: new CalendarEventBase({
				start: startDate.getTime(),
				end: config.datesType !== 'onlyStart' ? endDate.getTime() : null,
				timezone: config.timeZone ?? ApplicationState.timezone,
				comment: config.comment,
			}),
			onCancel: () => {
				resolve(false);
				config.onCancel?.();
			},
			datesType: config.datesType,
			startIsCurrentTime: config.startIsCurrentTime ?? moment(config.date).isSame(moment(), 'day'),
			onSave: async (ev) => {
				await config.onSave?.(ev);
				resolve(true);
			},
			mode: 'create',
			positionType: config?.positionType ?? ModalPosition.Centered,
			positionAnchor: config.anchor,
			disableRrule: config.disableRrule,
			infoMessage: config.infoMessage,
		});
	});
}

const getStartTime = (date: Date, timeZone?: string) => {
	if (moment(date).isSame(moment(), 'date')) {
		const current = moment()
			.add(getTzOffsetDiffs(timeZone ?? ApplicationState.timezone, moment.tz.guess()), 'minutes')
			.toDate();
		return [current.getHours(), current.getMinutes(), current.getSeconds()];
	}
	return [8, 0, 0];
};
